/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_functional_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_functional_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_js_functional_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_widgets_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_widgets_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_js_widgets_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_css_main_styl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_css_main_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_css_main_styl__);




/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elements = document.querySelectorAll('.element');

elements.forEach(function (element) {
  var btn = element.querySelector('.question button');
  var question = element.querySelector('.question');
  var icon = element.querySelector('.question button i');
  var answer = element.lastElementChild;
  var answers = document.querySelectorAll('.element .answer');

  question.addEventListener('click', function () {
    answers.forEach(function (ans) {
      // let ansIcon = ans.parentElement.querySelector('button i');
      if (answer === ans) {
        ans.classList.toggle('is-hidden');
        // ansIcon.className = 'fas fa-plus-circle';
      }
    });

    // answer.classList.toggle('is-hidden');
  });
});

document.querySelectorAll('.header__nav-item').forEach(function (el) {
  var currentPage = location.origin + location.pathname;
  if (el.href === currentPage) {
    el.classList.add('active');
  }
});

/***/ }),
/* 3 */
/***/ (function(module, exports) {

function merch38WidgetsInit() {
  document.querySelectorAll('[data-merch38-id]').forEach(function (el) {
    var defaultColor = el.getAttribute('data-merch38-defaultColor');
    window.merch38Widget({
      el: el,
      defaultColor: defaultColor || 'black',
      campaignId: el.getAttribute('data-merch38-id'),
      appearance: {
        mainColor: '#5062c2',
        btnText: 'BUY',
        btnTextColor: '#ffffff'
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", merch38WidgetsInit);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js